import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { GlobalState } from '../../../../store/global/global.state';
import { take } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { selectToken } from '../../../../store/global/global.selectors';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const store = inject<Store<GlobalState>>(Store);

    return store.select(selectToken).pipe(
        take(1),
        switchMap((token) => {
            if (!token) {
                return next(req);
            }

            const modifiedRequest = req.clone({
                headers: req.headers.set(
                    'Authorization',
                    'Bearer ' + token,
                ),
            });

            return next(modifiedRequest);
        }),
    );
};
